(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pae", [], factory);
	else if(typeof exports === 'object')
		exports["pae"] = factory();
	else
		root["pae"] = factory();
})(window, function() {
return 